module.exports = __webpack_public_path__ + "img/b678a23.jpg";